<template>
    <div class="vertical-bar-chart">
        <bar-chart ref="barChart"  :data="data" :options="options" @changeData="onChangeData()">></bar-chart>

        <!-- Custom legend -->
        <div class="bar-legend">
            <ul>
                <el-checkbox-group v-model="checkedActivities" class="flex-level jc-center">
                    <el-checkbox v-for="(dataset, index) in data.datasets"  checked @change="isChecked => handleFilterLegendChange(isChecked, index)" :key="index" :label="index" class="mr-6">
                        <chip-label :color="dataset.backgroundColor" :label="dataset.label" gap="small" />
                    </el-checkbox>
                </el-checkbox-group>
            </ul>
        </div>

    </div>
</template>

<script>
    import BarChart from './VerticalBar.js'
    import './BarChartRounded.js'
    import ChipLabel from "vcomponents/utilities/ChipLabel.vue";

    export default {
        name: 'VerticalBarChart',
        props: {
            data : {
                type: Object,
                required: true
            }
        },
        data() {
            return {
                options: null,
                checkedActivities: [],
            }
        },
        created(){
            this.setOptions();
        },
        methods : {
            onChangeData() {
                this.data.datasets.forEach((_, index) => this.handleFilterLegendChange(this.checkedActivities.includes(index), index)); 
            },
            handleFilterLegendChange(isChecked, index) {
                const ci   = this.$refs.barChart.$data._chart;
                const meta = ci.getDatasetMeta(index);

                meta.hidden = !isChecked;
                ci.update();
            },
            /**
             * Set needed options for vertical bar chart
             */
            setOptions() {
                this.options = {
                    indexAxis: 'y',
                    responsive: true, 
                    maintainAspectRatio: false,
                    defaultFontFamily: "'Proxima Nova', 'Open Sans', sans-serif",
                    defaultFontSize: 14,
                    defaultFontStyle: "normal",
                    defaultFontColor: "#5C5C65",
                    isRoundedBar: true,
                    cornerRadius: 100, 
                    stackedRounded: true,

                    scales: {
                        xAxes: [{
                            id: 'bottom-x-axis',
                            position: 'bottom',
                            stacked: true,
                            categoryPercentage: 0.5,
                            barPercentage: .5,
                            gridLines: {
                                display: false,
                                color: '#D8D8E6',
                                borderDash: [5,5],
                                zeroLineWidth: 10,
                                drawTicks: false,
                            },
                            ticks: {
                                fontFamily: "'Proxima Nova', 'Open Sans', sans-serif",
                                fontSize: 14,
                                fontColor: "#5C5C65",
                                padding: 12,
                            },
                        }, {
                            id: 'top-x-axis',
                            position: 'top',
                            stacked: true,
                            gridLines: {
                                display: false,
                            },
                            ticks: {
                                display: false,
                            }
                        }],
                        yAxes: [{
                            id: 'left-y-axis',
                            position: 'left',
                            stacked: true,
                            gridLines: {
                                display: true,
                                color: '#D8D8E6',
                                borderDash: [5,5],
                                drawTicks: false,
                            },
                            ticks: {
                                fontFamily: "'Proxima Nova', 'Open Sans', sans-serif",
                                fontSize: 14,
                                fontColor: "#5C5C65",
                                padding: 12,
                                beginAtZero: true,
                                callback: function(value, index, values) {
                                    if (index !== (values.length - 1) && Math.floor(value) === value) return value;
                                },
                            }
                        }, {
                            id: 'right-y-axis',
                            position: 'right',
                            stacked: true,
                            gridLines: {
                                display: false,
                            },
                            ticks: {
                                display: false,
                            }
                        }],
                    },
                    legend: {
                        display: false,
                    },
                    tooltips: {
                        callbacks: {
                            label: function(tooltipItem, data) {
                                return `${data.datasets[tooltipItem.datasetIndex].label || ''} : ${Math.round(tooltipItem.yLabel * 100) / 100}`;
                            }
                        }
                    },
                    animation: {
                        duration: 400
                    }
                };
            }
        },
        components: {
            BarChart,
            ChipLabel
        },
    }

</script>
